import { nonEmptyString, PathnameStringCodec } from 'app/config/utils';
import * as t from 'io-ts';

const Environment = t.exact(t.interface({
  // Descriptive environment name.
  name: nonEmptyString,

  // Fallback domain name.
  domainName: nonEmptyString,

  // Location of external special pages. Pages loaded from this origin
  // have access to user information via postMessage.
  staticDomainName: nonEmptyString,

  // Location of the application under the domain name.
  basePath: PathnameStringCodec,

  // This is the domain where the API lives
  apiUrl: nonEmptyString,

  // Location of external assets, like bundles, fonts, images, etc.
  externalAssetBaseURL: t.union([t.null, nonEmptyString]),

  // Whether to redirect to the teacher domain when visiting the teacher recruitment pages
  teachDomainRedirect: t.boolean,

  // Whether or not to make shared cookies secure.
  insecureSharedCookies: t.boolean,

  // Id of GA4 All Site account
  ga4AllSiteGoogleAnalyticsId: nonEmptyString,
}), 'Environment');

export type IEnvironment = t.TypeOf<typeof Environment>;

export const getAssetBaseURL = (env: t.TypeOf<typeof Environment>) =>
  env.externalAssetBaseURL || env.basePath;

export default Environment;
